import { render, staticRenderFns } from "./ModalNotRelevantTask.vue?vue&type=template&id=1580b4de&"
import script from "./ModalNotRelevantTask.vue?vue&type=script&lang=js&"
export * from "./ModalNotRelevantTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports